import React, { type FunctionComponent, Fragment } from 'react'
import { type DashRouteComponentProps } from 'legacy/dash-components/dash-route/utils/dashRoute.types'
import DocumentTitle from 'legacy/components/DocumentTitle'
import { collectionsAdminRoutingConfig } from 'domains/collections/utils/collectionsRoutingConfig'
import { CollectionsEdit } from 'domains/collections/components/collections-edit/CollectionsEdit'
import { CollectionTypeEnum } from 'domains/collections/api'

interface Props
  extends DashRouteComponentProps<{
    collectionId: string
  }> {}

export const CollectionsAdminEditPage: FunctionComponent<Props> = ({ match }) => {
  const { collectionId } = match.params

  return (
    <Fragment>
      <DocumentTitle titleId="collectionsDomain.title" />

      <CollectionsEdit
        collectionId={collectionId}
        // TODO: Remove this retailerId, it's a required field on the api for now, but should be optional
        retailerId=""
        routingConfig={collectionsAdminRoutingConfig}
        collectionType={CollectionTypeEnum.Holiday}
      />
    </Fragment>
  )
}
